const initialState = {
  index: [],
  activeId: "",
  selected: [],
  data: {},
};

const SupportStatus = (state = initialState, action) => {
  switch (action.type) {
    case "SUPPORT_STATUS_INDEX":
      return { ...state, index: action.payload.index };
    case "SUPPORT_STATUS_ACTIVE_ID":
      return { ...state, activeId: action.payload.activeId };
    case "SUPPORT_STATUS_SELECTED":
      return { ...state, selected: action.payload.selected };
    case "SUPPORT_STATUS_DATA":
      return { ...state, data: action.payload.data };
    case "SUPPORT_STATUS_RESET":
      return initialState;
    default:
      return state;
  }
};

export default SupportStatus;
